import IntlMessages from 'helpers/IntlMessages';
import React, { useEffect, useState } from 'react';
import { useHistory, useLocation } from 'react-router-dom';

const validId = (value: string | null): value is string =>
  !!value && /^\d+$/.test(value) && Number.isSafeInteger(Number(value)) && Number(value) > 0;

/** The Chat header passes IDs only as navigation hints; ARK resolves the destination. */
const ChatFromDiscourse = (): React.ReactElement => {
  const history = useHistory();
  const location = useLocation();
  const [unavailable, setUnavailable] = useState(false);

  useEffect(() => {
    const params = new URLSearchParams(location.search);
    const categoryId = params.get('categoryId');
    const channelId = params.get('channelId');
    const mode = params.get('mode');
    if (!validId(categoryId) || !validId(channelId) || (mode !== 'page' && mode !== 'invite')) {
      setUnavailable(true);
      return;
    }

    let active = true;
    fetch(`/api/discourse/chat-space/${categoryId}`, { credentials: 'same-origin' })
      .then(async response => {
        if (!response.ok) throw new Error('No linked ARK page');
        return response.json();
      })
      .then(space => {
        if (!active) return;
        if (mode === 'page') {
          history.replace(space.path);
        } else {
          history.replace(`/chat/create-invite?categoryId=${categoryId}&channelId=${channelId}`);
        }
      })
      .catch(() => { if (active) setUnavailable(true); });

    return () => { active = false; };
  }, [history, location.search]);

  return <main className="container py-4">
    <p><IntlMessages id={unavailable ? 'chat.link-unavailable' : 'general.loading'} /></p>
  </main>;
};

export default ChatFromDiscourse;
